import { Button } from '@dc-shared-web/components/shadcn'
import { Icon } from '@dc-shared-web/components/base'
import { faLink } from '@document-crunch/pro-regular-svg-icons'

export function CopyLink({
  documentId,
  setCopyLinkText,
  copyLinkText,
}: {
  documentId: string
  setCopyLinkText: (text: string) => void
  copyLinkText: string
}) {
  // CHANGE TO TRIGGER GITHUB ACTION
  const handleCopyLink = () => {
    navigator.clipboard.writeText(
      `${window.location.origin}/crunches/${documentId}?copyShareLink=true`
    )
    setCopyLinkText('Link copied!')
    setTimeout(() => {
      setCopyLinkText('Copy link')
    }, 2000)
  }

  return (
    <div className='tw-absolute tw--bottom-16 tw-left-0 tw-right-0 tw-bg-white tw-py-2 tw-px-6 tw-rounded-lg tw-w-full'>
      <div className='tw-flex tw-items-center tw-justify-between tw-gap-1 tw-w-full'>
        <p className='tw-text-sm tw-font-medium tw-text-neutral-700'>
          Only people with access can open link
        </p>
        <Button
          size='sm'
          onClick={handleCopyLink}
          data-testid={`share-modal-copy-link-btn`}
          className='tw-font-medium tw-text-blue-600 tw-text-sm tw-flex tw-items-center tw-gap-2 hover:tw-text-blue-800'
          variant={'outline'}
        >
          <Icon icon={faLink} size='sm' className='tw-text-blue-600' />
          {copyLinkText}
        </Button>
      </div>
    </div>
  )
}
